import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import { Theme } from '../SectionWrapper/SectionWrapper';
import S from './SectionInfoContainer.styles';
const SectionInfoContainer = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.TopContainer, null,
            props.title ? React.createElement(S.Title, null, props.title) : null,
            props.cta && props.ctaPosition === 'above' ? renderCta(props.cta) : null,
            props.description ? (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: props.description } })) : null),
        props.children,
        props.cta && props.ctaPosition !== 'above' ? (React.createElement(S.CtaWrapper, null, renderCta(props.cta))) : null));
    function renderCta(cta) {
        return (React.createElement(LinkButton, { buttonType: props.ctaType ?? 'default', href: cta.url, icon: cta.icon, target: cta.target }, cta.text));
    }
};
const DARK_THEMES = [
    Theme.Blue,
    Theme.BlueGradient,
    Theme.GreenGradient,
    Theme.OrangeGradient,
    Theme.PurpleGradient,
    Theme.RedGradient,
];
export function getButtonType(ctaType, theme) {
    if (ctaType === 'text') {
        return theme && DARK_THEMES.includes(theme) ? 'text-only-inverted' : 'text-only';
    }
    return theme && DARK_THEMES.includes(theme) ? 'inverted' : 'default';
}
export default SectionInfoContainer;
